import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {
	FormBuilder,
	FormControl,
	FormGroup,
	Validators,
} from '@angular/forms';
import { AuthService } from '../../../../core/http/auth/auth.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-welcome-code',
	templateUrl: './welcome-code.component.html',
	styleUrls: ['./welcome-code.component.scss'],
})
export class WelcomeCodeComponent {
	//Esto permite que el invalid tooltip no se muestre al inicio
	submitted = false;

	//Propiedades
	public code_residence: string;
	public txt1: string;
	public txt2: string;
	public txt3: string;
	public txt4: string;
	//Variable error de código welcome
	public errorMessage: string = '';

	onKeydown(event) {
		if (event.key === 'Enter') {
			this.submitWelcome();
		}
	}

	//* FORM WELCOME CODE ------------------------------------------------------------>
	myWelcome = this.fb.group({
		txt1: [, [Validators.required]],
		txt2: [, [Validators.required]],
		txt3: [, [Validators.required]],
		txt4: [, [Validators.required]],
	});

	//* CONSTRUCTOR ------------------------------------------------------------>
	constructor(
		private _authService: AuthService,
		private _router: Router,
		private fb: FormBuilder
	) {}

	//* NgOnInit ------------------------------------------------------------>
	ngOnInit(): void {
		localStorage.removeItem('residential_propierty');
	}

	//ERRORS
	get txtErrorsMsg(): string {
		const error1 = this.myWelcome.get('txt1')?.errors;
		const error2 = this.myWelcome.get('txt2')?.errors;
		const error3 = this.myWelcome.get('txt3')?.errors;
		const error4 = this.myWelcome.get('txt4')?.errors;

		if (
			error1?.required ||
			error2?.required ||
			error3?.required ||
			error4?.required
		) {
			return 'message.required';
		}

		// Devuelve el mensaje de error definido en la variable de clase
		return this.errorMessage;
	}

	//VALIDACIONES DE CAMPOS
	validacionCampo() {
		return this.myWelcome.invalid && this.myWelcome.touched;
	}

	public async submitWelcome() {
		//ACTIVA LOS INVALID TOOLTIP
		this.submitted = true;

		if (this.myWelcome.invalid) {
			// Comprueba si el formulario es inválido
			this.myWelcome.markAllAsTouched(); // Marca todos los campos del formulario como "tocado" para que se muestren los errores de validación
			return;
		}
		// Obtiene los valores de los campos del formulario
		this.txt1 = String(this.myWelcome.value.txt1);
		this.txt2 = String(this.myWelcome.value.txt2);
		this.txt3 = String(this.myWelcome.value.txt3);
		this.txt4 = String(this.myWelcome.value.txt4);
		// Concatena los valores de los campos del formulario para formar un código de residencia
		this.code_residence = this.txt1 + this.txt2 + this.txt3 + this.txt4;

		// Crea un objeto "body" que contiene los datos que se enviarán en una petición HTTP
		let body: object = {
			leng: localStorage.getItem('language'),
			code_propierty: this.code_residence.padStart(4, '0'),
		};
		// Envía una petición HTTP asincrónica para validar el código de residencia
		let res: any = await this._authService.validateResidenceCode(body);
		if (!res.mensaje_return.ERROR) {
			localStorage.setItem(
				'residential_propierty',
				JSON.stringify(res.residential_propierty)
			);
			this._router.navigateByUrl('/auth/step-1');
		} else {
			// Si el código de residencia es inválido, muestra un mensaje de error en la consola
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'Wrong code. Please try again',
				//   footer: '<a href="">Why do I have this issue?</a>'
			});
		}
		// Reinicia el formulario
		this.myWelcome.reset();
	}
}
